import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../services/apiService';
import { toast } from 'react-toastify';

const Suggestions = () => {
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const fetchSuggestions = async () => {
    try {
      const response = await apiService.get('suggestionList');
      if (response.data) {
        setSuggestions(response.data);
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteSuggestion = async () => {
    try {
      const response = await apiService.get(`deleteSuggestion/${deleteId}`);
      if (response.success) {
        toast.error(response.message);
      } else {
        toast.success('Suggestion deleted successfully');
        setShowDeleteModal(false);
        fetchSuggestions();
      }
    } catch (error) {
      toast.error('Something went wrong, try again!!');
      console.error(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="flex-1 overflow-auto bg-gray-50">
      <div className="bg-white rounded-lg shadow-sm m-0">
        <div className="flex items-center justify-between p-2 border-b">
          <div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Suggestions</h1>
            <nav className="flex text-sm text-gray-600">
              <span className="cursor-pointer hover:text-[#009ef7]" onClick={() => navigate('/dashboard')}>Home</span>
              <span className="mx-2">/</span>
              <span className="text-gray-900">Suggestions</span>
            </nav>
          </div>
        </div>

        <div className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-xs sm:text-sm">
              <thead>
                <tr className="bg-gray-50 text-gray-600 text-sm">
                  <th className="px-4 py-3 text-left font-semibold min-w-[125px]">Name</th>
                  <th className="px-4 py-3 text-left font-semibold min-w-[125px]">Email</th>
                  <th className="px-4 py-3 text-left font-semibold min-w-[300px]">Message</th>
                  <th className="px-4 py-3 text-left font-semibold min-w-[100px]">Date</th>
                  <th className="px-4 py-3 text-center font-semibold min-w-[50px]">Action</th>
                </tr>
              </thead>
              <tbody>
                {suggestions.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-4 py-8 text-center text-gray-500">
                      No suggestions found
                    </td>
                  </tr>
                ) : (
                  suggestions.map((suggestion) => (
                    <tr key={suggestion._id} className="border-b hover:bg-gray-50">
                      <td className="px-4 py-3 text-gray-900">
                        {suggestion.vendorId?.name || '--'}
                      </td>
                      <td className="px-4 py-3 text-gray-900">
                        {suggestion.vendorId?.email || '--'}
                      </td>
                      <td className="px-4 py-3 text-gray-900">
                        {suggestion.message || '--'}
                      </td>
                      <td className="px-4 py-3 text-gray-900">
                        {formatDate(suggestion.createdAt)}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() => confirmDelete(suggestion._id)}
                          className="inline-flex items-center justify-center w-8 h-8 bg-red-50 text-red-600 rounded hover:bg-red-100"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-md">
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="text-lg font-semibold">Confirmation</h3>
              <button onClick={() => setShowDeleteModal(false)} className="text-gray-400 hover:text-gray-600">
                <i className="bi bi-x text-2xl"></i>
              </button>
            </div>
            <div className="p-6">
              <p className="text-gray-700">Are you sure you want to delete this Suggestion?</p>
            </div>
            <div className="flex flex-col sm:flex-row justify-end gap-3 p-4 border-t">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={deleteSuggestion}
                className="px-6 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Suggestions;
